module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/title_banner_top-717d5f8b26a50fc8df96452777f0004e.png";